export const pagination = {
    PAGE_SIZE: 10,
};
//# sourceMappingURL=pagination.js.map